/**
 * assets/filter-edu-popup.js - FINAL VERSION (Show Twice Per Session)
 *
 * This version appears a maximum of two times per browser session on collection pages
 * where no filter is currently active.
 */
(function () {
  const FilterEduPopup = {
    // --- Configuration ---
    VIEW_COUNT_KEY: 'filterEduPopupViewCount', // The key for the session counter
    MAX_VIEWS: 2, // The maximum number of times the popup can appear
    TOGGLE_SELECTORS: [
      '[data-toggle-filters]',
      '#FilterToggleButton',
      '#SortBy-mobile',
      '[aria-controls*="FilterDrawer"]',
      '.collection-filters__btn',
      'button.button--secondary[aria-controls*="filter"]',
      '.mobile-facets__open'
    ],
    DEBUG: false,

    log(...args) {
      if (this.DEBUG) console.log('[FilterEduPopup]', ...args);
    },

    getViewCount() {
      const count = parseInt(sessionStorage.getItem(this.VIEW_COUNT_KEY), 10);
      return isNaN(count) ? 0 : count;
    },

    incrementViewCount() {
      const newCount = this.getViewCount() + 1;
      try {
        sessionStorage.setItem(this.VIEW_COUNT_KEY, newCount);
        this.log(`View count incremented to ${newCount}.`);
      } catch (e) {
        this.log('Could not write view count to sessionStorage.', e);
      }
    },

    findFilterToggle() {
      for (const selector of this.TOGGLE_SELECTORS) {
        const element = document.querySelector(selector);
        if (element && (element.offsetWidth > 0 || element.offsetHeight > 0)) {
          return element;
        }
      }
      return null;
    },

    render(toggle) {
      // Increment the counter as soon as we decide to render
      this.incrementViewCount();
    
      const rect = toggle.getBoundingClientRect();
      const popup = document.createElement('div');
      const overlay = document.createElement('div');
      overlay.id = 'filter-edu-popup-overlay';

      popup.className = 'filter-edu-popup';
      popup.setAttribute('dir', 'rtl');
      popup.innerHTML = `<h3>اعثر على ما يناسبك</h3><p>استخدم هذا الزر لفرز المنتجات أو تصفيتها حسب المقاس واللون وغير ذلك.</p><button class="filter-edu-popup-close">حسناً، فهمت</button>`;
      
      document.body.append(overlay, popup);

      // Positioning Logic
      const popupTop = rect.bottom + 16;
      popup.style.top = `${popupTop}px`;
      const toggleCenter = rect.left + rect.width / 2;
      let popupLeft = toggleCenter - popup.offsetWidth / 2;
      popupLeft = Math.max(10, Math.min(popupLeft, window.innerWidth - popup.offsetWidth - 10));
      popup.style.left = `${popupLeft}px`;
      popup.classList.add('point-down');

      const arrowAlignment = toggleCenter - popupLeft;
      if (arrowAlignment < 50) { popup.classList.add('align-left'); }
      else if (arrowAlignment > popup.offsetWidth - 50) { popup.classList.add('align-right'); }
      else { popup.classList.add('align-center'); }

      requestAnimationFrame(() => {
        overlay.classList.add('visible');
        popup.classList.add('visible');
      });

      const close = () => {
        overlay.classList.remove('visible');
        popup.classList.remove('visible');
        setTimeout(() => { popup.remove(); overlay.remove(); }, 300);
        document.removeEventListener('keydown', onKeydown);
        document.body.dispatchEvent(new CustomEvent('filter-edu-popup:finished'));
      };

      popup.querySelector('.filter-edu-popup-close').addEventListener('click', close);
      overlay.addEventListener('click', close);
      const onKeydown = (e) => e.key === 'Escape' && close();
      document.addEventListener('keydown', onKeydown);
    },

    init() {
      const dispatchFinishEvent = () => document.body.dispatchEvent(new CustomEvent('filter-edu-popup:finished'));

      try {
        const viewCount = this.getViewCount();
        if (viewCount >= this.MAX_VIEWS) {
          this.log(`Exiting: Max views (${this.MAX_VIEWS}) reached.`);
          dispatchFinishEvent();
          return;
        }

        const isOnCollectionPage = window.location.pathname.indexOf('/collections') > -1;
        const filtersAreActive = window.location.search.includes('filter.');

        if (!isOnCollectionPage || filtersAreActive) {
          dispatchFinishEvent();
          return;
        }

        const filterToggle = this.findFilterToggle();
        if (filterToggle) {
          this.log(`Conditions met. Rendering popup (View #${viewCount + 1}).`);
          this.render(filterToggle);
        } else {
          dispatchFinishEvent();
        }
      } catch(e) {
        console.error('Error in FilterEduPopup:', e);
        dispatchFinishEvent();
      }
    }
  };

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', () => setTimeout(FilterEduPopup.init.bind(FilterEduPopup), 1000));
  } else {
    setTimeout(FilterEduPopup.init.bind(FilterEduPopup), 1000);
  }
})();